import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';

export default function LogoutButton() {
    const navigate = useNavigate();

    const userData = JSON.parse(localStorage.getItem('GB_User_Data'));
    const isFreeUser = userData?.isFree === true;

    if (isFreeUser) return null;

    const handleLogout = () => {
        localStorage.removeItem('GB_User_Data');
        window.location.reload();
    };

    return (
        <button onClick={handleLogout} className="btn btn-primary m-2 d-flex align-items-center gap-2 mt-auto">
            <LogOut size={20} />
            Logout
        </button>
    );
}
